export type Interceptor = () => Promise<void>

export class InterceptorsAPI {
  private interceptors = new Map<string, Interceptor[]>()

  private getInterceptorsByEvent = (eventName: string): Interceptor[] => {
    return this.interceptors.get(eventName) ?? []
  }

  registerInterceptor = (eventName: string, interceptor: Interceptor) => {
    const interceptors = this.getInterceptorsByEvent(eventName)
    this.interceptors.set(eventName, [...interceptors, interceptor])
  }

  unregisterInterceptor = (eventName: string, interceptor: Interceptor) => {
    if (!this.interceptors.has(eventName)) {
      return
    }
    const interceptors = this.getInterceptorsByEvent(eventName)
    this.interceptors.set(
      eventName,
      interceptors.filter(item => item !== interceptor),
    )
  }

  invokeInterceptors = async (eventName: string): Promise<void> => {
    await Promise.all(
      this.getInterceptorsByEvent(eventName).map(interceptor => interceptor()),
    )
  }
}
